import r from "../managers/braze-instance.js";
import { IamStrings as sr } from "./constants.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import je from "./in-app-message-manager-factory.js";
import { logger as E } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageButtonClick(t, o) {
  var e;
  if (!r.rr()) return !1;
  if (!(t instanceof InAppMessageButton))
    return E.error("button must be an InAppMessageButton object"), !1;
  if (!(o instanceof InAppMessage)) return E.error(sr.sS), !1;
  const s = je.ra().Rn(t, o);
  if (s.W)
    for (let r = 0; r < s.Ee.length; r++)
      rt.o().he(
        ot.rm,
        [
          o.triggerId,
          null === (e = t.id) || void 0 === e ? void 0 : e.toString(),
        ],
        s.Ee[r],
      );
  return s.W;
}
